export const Routes = {
    HOME: "/",
    INDUCT_LOCATION_WITH_PROPS: "/inductLocation/:flow",
    INDUCT_LOCATION_WITHOUT_PROPS: "/inductLocation/",
    RECEIVE_PACKAGE_WITH_PROPS: "/receivePackage/:flow/:inductLocation",
    RECEIVE_PACKAGE_WITHOUT_PROPS: "/receivePackage/",
    SCAN_PRINTER_WITH_PROPS: "/scanPrinter/:flow/:inductLocation",
    SCAN_PRINTER_WITHOUT_PROPS: "/scanPrinter/",
    NEW_SESSION: "/newSession"
};

export const Flow = {
    SCAN: "scan",
    PRINT: "print"
};


// WEBPACK FOOTER //
// ./src/components/utils/Routes.js